import React, { useState, useEffect,useReducer } from "react";
import { HashRouter as Router, Route } from "react-router-dom";
import { AuthContext } from "../lib/auth";
import { GlobalContext,storeReducer } from "../lib/auth/globalStore";
import PrivateRoute from "./PrivateRoute";
import Login from "./Login";
import TillReg from "./TillRegistration";
import PointOfSale from "./PointOfSale";
import Dashboard from "./Dashboard";
import Sync from "./Sync";
import OpenTill from "./OpenTill";
import OpenTillComponent from "./OpenTill/OpenTillComponent";
import CloseTill from "./CloseTill";
import CloseTillAll from "./CloseTill/CloseTIllAll";
import TableManagement from "./PointOfSale/Restaurant/Tables-Management/tables";
import BillManagement from "./PointOfSale/Restaurant/billManagement";
import DayClose from "./DayClose";
import PurchaseGRN from "./PurchaseGrn";
import STReceipt from "./STReceipt";
import WastageQty from "./wastageQty";
import B2BSales from "./B2BSales";
import PriceUpdate from "./PriceUpdate";
import Till from "./Till/Till";
import "./style.css";
import serviceWorker from "../serviceWorker";
import ErrorBoundary from './ErrorBoundary';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const App = (props) => {
  const [authTokens, setAuthTokens] = useState(localStorage.getItem("tokens"));
  // const setTokens = (data) => {
  //   localStorage.setItem("tokens", JSON.stringify(data));
  //   setAuthTokens(data);
  // };
  const setTokens = () => {
    const getQueryParams = (location) => {
      const searchParams = new URLSearchParams(location.search);
      const params = {};
      for (const [key, value] of searchParams) {
        params[key] = value;
      }
      return params;
    };
    const location = window.location;
    const params = getQueryParams(location);
    if (params?.searchKey) {
      localStorage.setItem("tiilId",params?.searchKey)
      localStorage.setItem("tillName",params?.nameTill)
      // setAuthTokens(tokens)
    };
  };

  useEffect(() => {
    setTokens();
  }, []);

//  serviceWorker();
let percent = "0%";
let productCategoryPercentage="0";
let productPercentage="0";
let promotionPercentage="0"
  const [globalStore, setGlobalStore] = useReducer(storeReducer, {
   percent:percent,
   productCategoryPercentage:productCategoryPercentage,
   productPercentage:productPercentage,
   promotionPercentage:promotionPercentage
  });

  return (
    <div className="aspectRatio">
            <GlobalContext.Provider value={{ globalStore, setGlobalStore }}>
      {/* <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}> */}
      <I18nextProvider i18n={i18n}>
        <Router>
        <Route exact path="/" component={Till} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/registration" component={TillReg} />
          <PrivateRoute exact path="/pos" component={PointOfSale} />
          <PrivateRoute exact path="/sync" component={Sync} />
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          <PrivateRoute exact path="/open-till" component={OpenTill} />
          <PrivateRoute exact path="/open-till-component" component={OpenTillComponent} />
          <PrivateRoute exact path="/close-till" component={CloseTill} />
          <PrivateRoute exact path="/close-till-all" component={CloseTillAll} />
          {/* <PrivateRoute exact path="/cash-event" component={CashEvent} /> */}
          <PrivateRoute exact path="/table-management" component={TableManagement} />
          {/* <PrivateRoute exact path="/bill-management" component={BillManagement} /> */}
          <PrivateRoute exact path="/day-close" component={DayClose} />
          <PrivateRoute exact path="/purchase-grn" component={PurchaseGRN} />
          <PrivateRoute exact path="/stock-receipt" component={STReceipt} />
          <PrivateRoute exact path="/wastage-qty" component={WastageQty} />
          <PrivateRoute exact path="/b2b-sales" component={B2BSales} />
          <PrivateRoute exact path="/price-update" component={PriceUpdate} />
          {/* <PrivateRoute exact path="*" component={ErrorBoundary} /> */}
        </Router>
        </I18nextProvider>
        </GlobalContext.Provider>
      {/* </AuthContext.Provider> */}
    </div>
  );
};

export default App;
